import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import OrgMemberList from "./OrgMemberList/OrgMemberList";
import OrganizationInfo from "./OrganizationInfo/OrganizationInfo";
import { Organization_GetOne_Response, OrganizationAPIs } from "~/common/typescript/apis/OrganizationAPIs";
import { UI_ScreenStyles } from "../UI_ScreenStyles";
import { createBreadcrumbItems, commonBreadcrumbs } from "~/utils/breadcrumbUtils";
import Routes from "~/routes/routes";

const OrganizationDetailScreen = () => {
  const { t } = useTranslation();
  const { organizationID } = useParams();
  const [organization, setOrganization] = useState<Organization_GetOne_Response>();

  const fetchData = async () => {
    if (organizationID) {
      try {
        const orgData = await OrganizationAPIs.remote_getOne(Number(organizationID));
        setOrganization(orgData);
      } catch (error) {
        console.error('Error fetching organization:', error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [organizationID]);

  return (
    <UI_ScreenStyles.UI_Wrapper>
      <UI_ScreenStyles.UI_Breadcrumb
        items={createBreadcrumbItems([
          commonBreadcrumbs.home,
          { title: 'Doanh nghiệp', href: Routes.ORGANIZATION, icon: commonBreadcrumbs.organizations.icon },
          { title: organization?.name || 'Chi tiết' }
        ])}
      />

      <UI_ScreenStyles.UI_Content_Wrapper>
        <OrganizationInfo organization={organization} />
        <OrgMemberList />
      </UI_ScreenStyles.UI_Content_Wrapper>
    </UI_ScreenStyles.UI_Wrapper>
  )
}

export default memo(OrganizationDetailScreen);